export interface PreAppointmentOption {
  value: string
  displayName: string
  isActive: boolean
  waitwhileServiceId?: string
  duration?: number
}

export interface PreAppointmentCategory {
  categoryName: string
  categoryDisplayName: string
  options?: PreAppointmentOption[]
}

export interface PreAppointmentPurposeData {
  categories: PreAppointmentCategory[]
}

export interface SelectedPurposeOption {
  value: string
  waitwhileServiceId?: string
  duration?: number
}

export interface PreferenceSelection {
  category: string
  value: string
}

export interface UpdateAppointmentPurposePayload {
  visitId: string
  selections: PreferenceSelection[]
  notes: string
  serviceId?: string
  duration?: number
}

/** API category rendered on the purpose screen (legacy AppointmentPurpose1). */
export const PURPOSE_CATEGORY_NAME = 'AppointmentPurpose1'
